import { useFetchPageInfo } from "@/apis/queryFunctions/pageInfo";
import DefaultSEO from "@/common/components/DefaultSEO";
import { useRouter } from "next/router";
import React, { useState } from "react";
import Career from "./components/Career";
import HRTerm from "./components/HRTerm";

const TabsLabel = {
  vi: [
    {
      value: "1",
      label: "Cơ hội nghề nghiệp",
    },
    {
      value: "2",
      label: "Chính sách nhân sự",
    },
  ],
  en: [
    {
      value: "1",
      label: "Career opportunities",
    },
    {
      value: "2",
      label: "HR policies",
    },
  ],
};

const seo = {
  vi: {
    title: "Tuyển dụng",
  },
  en: {
    title: "Recruitment",
  },
};

export default function LienHe() {
  // const { getLabel } = useLocalContext();
  const { locale } = useRouter();

  const [activeTab, setActiveTab] = useState("1");
  const { data } = useFetchPageInfo("chinh-sach-nhan-su", locale);
  return (
    <div style={{ paddingBottom: 55 }}>
      <DefaultSEO seo={seo[locale]} />
      {/* <TittleBanner position="career" label="Tuyển dụng" /> */}
      {/* <Tab
        tab={TabsLabel[locale]}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
       /> */}

      <section>
        <div style={{ paddingTop: 60 }}>
          {activeTab == "2" ? (
            <>
              {data &&
                data.add_on_data.map((item, index) => (
                  <HRTerm
                    key={`content${index}`}
                    title={item.title}
                    label={item.content}
                    index={index}
                    src={item.picture}
                   />
                ))}
            </>
          ) : (
            <Career />
          )}
        </div>
      </section>
    </div>
  );
}
